require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/fn/symbol/iterator.js
// module id = 207
// module chunks = 1